import createActionHandlers from '@sift/resift/redux/FetchUtils/createActionHandlers';

export const CREATE_ATTRIBUTE_DIALOG_TOGGLE = 'CREATE_ATTRIBUTE_DIALOG_TOGGLE';
export const CATEGORY_FIELD_CREATE = 'CATEGORY_FIELD_CREATE';
export const CATEGORY_FIELD_CREATE_SUCCESS = 'CATEGORY_FIELD_CREATE_SUCCESS';
export const CATEGORY_FIELD_CREATE_ERROR = 'CATEGORY_FIELD_CREATE_ERROR';

export function toggleCreateAttributeDialog() {
  return {
    type: CREATE_ATTRIBUTE_DIALOG_TOGGLE,
    payload: {},
  };
}

// Used on Attribute Create Dialog because I need access to the returned value from the dispatch call
export function createCategoryField(data) {
  return {
    type: CATEGORY_FIELD_CREATE,
    identifier: 'attribute',
    payload: {
      data,
    },
  };
}

// Action Handlers
export const initialState = {
  fetches: {},
  objects: {},
  isCreateAttributeDialogOpen: false,
};

const ACTION_HANDLERS = {
  [CREATE_ATTRIBUTE_DIALOG_TOGGLE]: state => {
    return {
      ...state,
      isCreateAttributeDialogOpen: !state.isCreateAttributeDialogOpen,
    };
  },
  ...createActionHandlers(CATEGORY_FIELD_CREATE),
};

// ------------------------------------
// Reducer
// ------------------------------------
export default function AttributeReducer(state = initialState, action) {
  const handler = ACTION_HANDLERS[action.type];

  return handler ? handler(state, action) : state;
}
